<template>
  <b-card>
    <b-row
      align-h="end"
      class="mr-0 mb-1"
    >
      <b-col cols="auto">
        <envio-email-em-lote
          :empresas-selecionadas="empresasSelecionadas"
          :empresas-grid="empresasGrid"
          title="Enviar CCMEI por e-mail"
          nome-arquivo="CCMEI"
          alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
          :evento="enviarEmailEmLote"
          :evento-verificar-email="verificarEmail"
        />
      </b-col>
    </b-row>
    <cc-mei-list
      ref="ccMeiList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      @carregado="dadosGrid = $event"
      @selected-rows-change="empresasSelecionadas = $event"
    >
      <template
        slot="custom"
        slot-scope="{ props }"
      >
        <b-badge
          v-if="props.column.field === 'situacaoCadastral'"
          :variant="getVariantSituacao(props.row[props.column.field])"
        >
          {{ props.row[props.column.field] }}
        </b-badge>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          @atualizar-grid="atualizarGrid"
        />
      </template>
    </cc-mei-list>
  </b-card>
</template>

<style lang="scss">
.col-tamanho-cnpj {
  min-width: 194px !important;
}
</style>

<script>
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import colunas from './config/colunas'
import filtrosRapidosConfig from './config/filtrosRapidos'
import api from './services/api'

export default {
  name: 'CcMeiView',
  components: {
    CcMeiList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    EnvioEmailEmLote: () => import('@app/shared/components/envio-email-lote/EnvioEmailEmLote.vue'),
  },
  data() {
    return {
      apiCcMei: api,
      botoesOption: null,
      visualizacao: {
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: false,
        placeholderBusca: 'Buscar por Razão Social, CNPJ/CPF',
        colunas,
        evento: this.carregar,
      },
      filtros: [{ colunas: ['CadastroFederal', 'RazaoSocial', 'CadastroFederalSemMascara'], valor: null }],
      filtrosRapidos: filtrosRapidosConfig,
      filtroAtual: {},
      dadosGrid: [],
      empresasSelecionadas: [],
    }
  },
  computed: {
    empresasGrid() {
      return this.dadosGrid
    },
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    verificarEmail(ids) {
      return api.verificarEmail(ids)
    },

    enviarEmailEmLote(nomeArquivo, emails) {
      return api.enviarEmLote(nomeArquivo, emails)
    },

    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          try {
            const statusResp = await envioHistoricoApi.obterStatus(30, ids) // 30 = ETipoRotina.CCMei
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },

    baixarEmLote(evt) {
      api.baixaEmLote(this.filtroAtual, evt)
    },

    atualizarGrid() {
      this.$refs.ccMeiList.refresh()
    },

    getVariantSituacao(situacao) {
      if (!situacao) return 'light-success'
      const s = situacao.toUpperCase()
      if (s === 'ATIVA') return 'light-success'
      if (s === 'BAIXADO' || s === 'BAIXADA') return 'light-danger'
      if (s === '-') return 'light-primary'
      return 'light-warning'
    },

    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.ccMeiList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.ccMeiList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
  },
}
</script>
